// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2LhoA","additionalInfo":"AgreementModal_additionalInfo__2AULg"};